import React from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import { MessageType } from '../../types';
import sortBy from 'lodash/sortBy';
import InboxMessagePreview from '../InboxMessagePreview';
import PropTypes from 'prop-types';
import './styles.css';

const READ_EMAIL = gql`
	mutation($gameID: ID!, $emailID: ID!) {
		readEmail(gameID: $gameID,emailID: $emailID) @client{
			id
			data
		}
	}
`;

const InboxMessagesList = props => {
	const { game } = props;
	return (
		<ul className="inbox-messages-list">
			{game.emails.length !== 0 &&
				sortBy(game.emails, ele => -ele.sentDate).map((message, index) => (
					<Mutation mutation={READ_EMAIL} key={index}>
						{readEmail => (
							<InboxMessagePreview
								readEmail={() =>
									readEmail({
										variables: {
											gameID: game.id,
											emailID: message.id
										}
									})
								}
								game={game}
								message={message}
							/>
						)}
					</Mutation>
				))}
		</ul>
	);
};

InboxMessagesList.propTypes = {
	getUrl: PropTypes.func,
	game: PropTypes.shape({
		emails: PropTypes.arrayOf(MessageType)
	})
};

export default InboxMessagesList;
